module.exports = __webpack_public_path__ + "static/media/intro-es-fr.602314ea.vtt";